import { images } from "utils/images"
import { masterBreakPoint, maxWidth600 } from "themes/default/breakpoints"
export const styles = {
  messageDetailUsername: {
    textAlign: "center",
    fontSize: 22,
    padding: "1rem",
    width: "100%",
    pb: 0.625,
    [masterBreakPoint]: {
      fontSize: 18,
      p: 1,
    },
  },
  messageDetailContent: {
    p: 0,
    borderRadius: "1rem",
  },
  commentsContainer: (theme) => ({
    backgroundColor: theme.palette.background.default,
    height: `calc(100vh - 300px)`,
    maxHeight: 500,
    minHeight: 200,
    p: 1.875,
    pb: 6.25,
    overflow: "auto",
  }),
  messageDetailStatus: (theme) => ({
    fontSize: 14,
    position: "relative",
    display: "block",
    top: -5,
    mt: "-30px",
    left: "50%",
    transform: "translate(-50%)",
    float: "none",

    height: 30,
    width: "120px",
    color: "#fff",
    lineHeight: "30px",
    borderRadius: "20px",
    textAlign: "center",
    backgroundColor: "#c00000",
  }),
  messageStatusOpen: (theme) => ({
    backgroundColor: "#00b050",
  }),
  closeButton: (theme) => ({
    position: "absolute",
    top: 5,
    right: 8,
    width: 50,
    height: 50,
    fontSize: 35,
    color: theme.palette.common.black,
    opacity: 0.54,
    transition: "transform 0.3s",
    "&:hover": {
      transform: "scale(1.3)",
      backgroundColor: "transparent",
    },
  }),
  closeIcon: {
    fontSize: 35,
  },
  dialog: {
    borderRadius: "1rem",
    maxWidth: "900px",
    width: "800px",
    [masterBreakPoint]: {
      m: 2,
    },
  },
  filePreviewDialog: {
    width: "90%",
    height: "90%",
    p: 6.25,
    pt: 3.75,
    borderRadius: 2.5,
  },
  messagePlatform: (theme) => ({
    position: "relative",
    float: "left",
    width: 25,
    height: 25,
    color: "#d8d8d8",
    fontStyle: "italic",
    lineHeight: "32px",
    right: 0,
    pl: 3.775,
    pr: 1.25,
    backgroindSize: "contain",
    cursor: "pointer",
    backgroundRepeat: "no-repeat",
    backgroundImage: `url(${images.codeComputer})`,
  }),
  messageHeader: (theme) => ({
    p: "1rem 2rem",
    backgroundColor: theme.palette.background.default,
    textAlign: "center",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    mb: 0,
    pb: "5px",
    [masterBreakPoint]: {
      p: 2,
    },
  }),
  messageScreenshot: (theme) => ({
    position: "relative",
    // width: 120,
    height: 32,
    color: "#d8d8d8",
    fontStyle: "italic",
    lineHeight: "32px",
    top: 0,
    right: 0,
    pl: 5,
    backgroundImage: `url(${images.pictures})`,
    backgroundSize: "contain",
    cursor: "pointer",
    backgroundRepeat: "no-repeat",
    transition: "all 0.4s",
    ml: "auto",
    mr: "5px",
    width: 40,
  }),
  messageMetadata: (theme) => ({
    display: "block",
    color: theme.palette.common.black,
    opacity: 0.5,
    clear: "both",
    fontSize: 12,
    overflow: "auto",
    margin: 0,
    textAlign: "center",
    flex: 1,
    textTransform: "capitalize",
    lineHeight: "32px",
  }),
  messageFooter: (theme) => ({
    p: 1.875,
    pt: 1.25,
    overflow: "visible",
    backgroundColor: "#818181",
    flexDirection: "column",
    gap: 1,
  }),
  messageDetails: (theme) => ({
    backgroundColor: theme.palette.background.default,
    opacity: 0.5,
    color: theme.palette.common.black,
    borderRadius: "10rem",
    fontSize: 16,
    "& .MuiInputBase-root": {
      height: "50px",
      overflow: "auto",
      p: "12px 15px",
      alignItems: "safe center",
    },
    "& fieldset": {
      borderWidth: "0px",
    },
    "& textarea": {
      lineHeight: 1.5,
      fontSize: 16,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderWidth: "0px",
    },
    "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderWidth: "0px",
    },
  }),
  sendButton: (theme) => ({
    width: 40,
    height: 40,
    ml: "5px",
    backgroundColor: "#00b050",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#087d3d",
    },
  }),
  messageActions: (theme) => ({
    color: "white",
  }),
  closeTicket: (theme) => ({
    fontSize: 14,
    p: "5px 10px",
    backgroundColor: "#e84040",
    color: "#fff",
    borderRadius: "20px",
    cursor: "pointer",
    lineHeight: "1",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#e84040",
    },
  }),
  toolbarButton: {
    p: "2px 10px",
    lineHeight: "1",
    borderRadius: "20px",
    color: "white",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "transparent",
    },
    "& .MuiButton-startIcon>*:nth-of-type(1)": {
      fontSize: 14,
    },
    "& .MuiButton-endIcon>*:nth-of-type(1)": {
      fontSize: 14,
    },
  },
  actionButtonRecording: {
    animation: "pulse-shadow linear 1.5s infinite",
  },
  actionButtonRecorded: (theme) => ({
    backgroundColor: theme.palette.background.default,
    color: "#84818a",
    mr: "8px!important",
    "&:hover": {
      backgroundColor: theme.palette.background.default,
    },
  }),
  grades: {
    flexDirection: "row",
    gap: 3,
    [maxWidth600]: {
      flexDirection: "column",
      justifyContent: "flex-start",
      gap: 1.5,
    },
  },
  gradeInput: (theme) => ({
    width: 75,
    borderRadius: 1.5,
    border: `1px solid ${theme.palette.grey.lighter3}`,
    backgroundColor: theme.palette.background.default,
    "& .MuiInputBase-readOnly": {
      backgroundColor: theme.palette.background.default,
      opacity: 0.9,
      border: `1px solid ${theme.palette.grey.lighter3}`,
    },
    "& .MuiInputBase-input": {
      width: 75,
      p: 0.625,
      textAlign: "center",
      color: theme.palette.primary.main,
      fontWeight: 500,
      // remove arrows
      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
        "-webkit-appearance": "none",
        margin: 0,
      },
      "&[type=number]": {
        "-moz-appearance": "textfield",
      },
    },
  }),
  gradeDetails: (theme) => ({
    position: "relative",
    mb: 1.25,
    color: theme.palette.primary.main,
    borderRadius: "1rem",
    p: "1rem",
    boxShadow: "rgba(0,0,0,.1) 0 0 5px 0,rgba(0,0,0,.1) 0 0 1px 0",
  }),
  gradeIcon: (theme) => ({
    position: "absolute",
    top: 10,
    right: 15,
    color: "rgba(0,0,0,.25)",
    fontSize: 30,
    "& svg": {
      fontSize: 30,
    },
  }),
  studentExerciseLink: (theme) => ({
    color: theme.palette.text.selected,
    fontStyle: "italic",
    textDecoration: "underline",
    cursor: "pointer",
    fontWeight: "700",
  }),
  gradeItem: {
    [maxWidth600]: {
      mt: 1,
    },
  },
}
